import { gql } from '@apollo/client'

export const GET_PROJECTS = gql`
  query ($limit: Int, $offset: Int, $sort: Boolean, $filters: CampaignsFilters) {
    getCampaigns(limit: $limit, offset: $offset, sort: $sort, filters: $filters) {
      artists {
        bio
        spotify_id
        facebook_id
        gfk_id
        gps_status
        id
        name
        opus_id
        social_media_kpi_facebook
        social_media_kpi_instagram
        social_media_kpi_twitter
        campaigns {
          global_status
          parent {
            global_status
          }
          editable
          active
          id
          info
          isaac_url {
            title
            url
          }
          main_product_id
          name
          owner_id
          project_id
          unit_id
          label_id
          created_at
          products {
            id
            name
            campaign_id
            configuration
            created_at
            active
            gpid
            gps_status
            publish_date
            updated_at
            parent_id
            facts {
              chart
              position_current
              product_id
              id
              peak
              position_current_at
              position_last
            }
          }
          user {
            country_code
            email
            first_name
            last_name
            id
            unit_id
          }
        }
      }
      total
    }
  }
`
